
// FormSearch.tsx
import { FaSearch} from "react-icons/fa";
import styles from "./IconSearch.module.scss";
import { useUIStore } from "../../../../store";




export const IconSearch = ()=> {

    const openSearch = useUIStore((state) => state.openSearch);


  return (
    <button className={styles.buttonIconSearch} > 
    <FaSearch onClick={openSearch}/>
      </button>
  );
}





